import DashboardService from '@/services/api/dashboard.services'
import EventsService from '@/services/api/events.services'
import store from "@/store";
import moment from 'moment-timezone'
import ApiClient from "@/libs/http-client";
import fireSwal from "@/helpers/fireSwal";

const translations = {
  dayOff: {
    ua: 'Вихідний',
    en: 'Day off',
    ru: 'Выходной'
  },
  vacation: {
    ua: 'Відпустка',
    en: 'Vacation',
    ru: 'Отпуск'
  },
  sickdays: {
    ua: 'Лiкарняний',
    en: 'Sickday',
    ru: 'Больничный'
  }
}

const state = {
  calendarDetails: null,
  candidatesData: {
    list: [],
    lastPage: null,
    perPage: null,
    total: null,
    currentPage: null,
  },
  candidatesForFilter: [],
  oneToOneReports: [],
  hrTodos: {
    created: [],
    active: [],
    completed: [],
  },
  generalTodos: {
    created: [],
    active: [],
    completed: [],
  },
  highestTaskId: 0,
  oneToOneMeetings: [],
  vacationsCalendar: [],
  daysOffCalendar: [],
  holidayCalendar: [],
  sickLealeCalendar: [],
  meetingsUsers: [],
  closeMeetings: [],
  closeCandidateMeetings: [],
  reportUser: {},
  vacationsCount: {},
  tags: {
    position: [],
    status: [],
    hr: [],
    technology_stack: [],
  },
}

const mutations = {

  SET_VACATIONS_COUNT(state, payload) {
    state.vacationsCount = payload
  },
  SET_TAGS(state, { type, data }) {
    state.tags[type] = data
  },
  //candidates
  SET_CANDIDATES(state, payload) {
    state.candidatesData.list = payload.candidates
    state.candidatesData.lastPage = payload.last_page
    state.candidatesData.perPage = payload.per_page
    state.candidatesData.currentPage = payload.current_page
    state.candidatesData.total = payload.total
  },
  SET_CANDIDATES_FOR_FILTER(state, payload) {
    if (!Array.isArray(payload)) {
      state.candidatesForFilter = []
      return
    }
    
    state.candidatesForFilter = payload.map(item => {
      const result = { ...item }
      
      if (!result.start && !result.end && item.last_connect) {
        result.date = item.last_connect
        result.start = item.start !== null && item.start !== undefined ? item.start : item.last_connect
        result.end = item.end !== null && item.end !== undefined ? item.end : item.last_connect
      }
      
      if (item.title && !result.title) {
        result.title = `${item.title}`
      }
      
      return result
    })
  },
  ADD_CANDIDATE(state, form) {
    state.candidates.push(form)
  },

  //to-dos
  SET_HR_TODOS(state, payload) {
    state.hrTodos = { created: [], active: [], completed: [] };
    payload.forEach(e => {
      switch (e.status) {
        case 'created':
          state.hrTodos.created.push(e);
          break
        case 'active':
          state.hrTodos.active.push(e);
          break;
        case 'completed':
          state.hrTodos.completed.push(e);
          break;
      }
    })

    if (payload[0]) {
      const { id } = payload.reduce((acc, curr) => {
        if (acc.id >= curr.id) return acc;
        else return curr;
      })
      if (state.highestTaskId <= id) state.highestTaskId = id;
    } else if (!payload[0]) {
      const id = 1;
      if (state.highestTaskId <= id) state.highestTaskId = id;
    }

  },
  SET_GENERAL_TODOS(state, payload) {
    state.generalTodos = { created: [], active: [], completed: [] };
    payload.forEach(e => {
      switch (e.status) {
        case 'created':
          state.generalTodos.created.push(e);
          break;
        case 'active':
          state.generalTodos.active.push(e);
          break;
        case 'completed':
          state.generalTodos.completed.push(e);
          break;
      }
    })

    if (payload[0]) {
      const { id } = payload.reduce((acc, curr) => {
        if (acc.id >= curr.id) return acc;
        else return curr;
      })
      if (state.highestTaskId <= id) state.highestTaskId = id;
    } else if (!payload[0]) {
      const id = 1;
      if (state.highestTaskId <= id) state.highestTaskId = id;
    }
  },
  CHANGE_TODO_STATUS(state, payload) {
    if (payload.managerType === 'hr') {
      let index = state.hrTodos.findIndex((e) => e.id === payload.todo.id)
      state.hrTodos[index].completed = payload.todo.completed
    } else {
      let index = state.generalTodos.findIndex(
        (e) => e.id === payload.todo.id,
      )
      state.generalTodos[index].completed = payload.todo.completed
    }
  },
  ADD_NEW_TODO(state, payload) {
    payload.currentManager === 'hr'
      ? state.hrTodos.push(payload.todo)
      : state.generalTodos.push(payload.todo)
    state.highestTaskId++
  },
  DELETE_TODO(state, payload) {
    if (payload.managerType === 'hr') {
      let index = state.hrTodos.findIndex((e) => e.id === payload.id)
      state.hrTodos.splice(index, 1)
    } else {
      let index = state.generalTodos.findIndex((e) => e.id === payload.id)
      state.generalTodos.splice(index, 1)
    }
  },
  //one-to-one meetings & reports
  SET_ONE_TO_ONE_MEETINGS(state, payload) {
    const meetings = payload
      .map((item) => {
        return {
          id: item.id,
          type: 'hr_meeting',
          additional_info: item.additional_info,
          author: item.author,
          client: item.client,
          title: item.client?.user_name,
          start: new Date(
            moment
              .utc(item.start)
              .tz(moment.tz.guess())
              .format()
          ),
          end: new Date(
            moment
              .utc(item.finish)
              .tz(moment.tz.guess())
              .format()
          ),
        }
      })

    state.meetingsUsers = meetings
    //     .reduce(
    //         (acc, user) => {
    //             if (acc.map[user.client.user_name]) return acc
    //
    //             acc.map[user.client.user_name] = true
    //             acc.users.push(user)
    //
    //             return acc
    //         },
    //         {
    //             map: {},
    //             users: [],
    //         },
    //     )
    //     .users.map((item) => {
    //         return {
    //             id: item.client.id,
    //             name: item.client.user_name,
    //         }
    //     })

    state.oneToOneMeetings = meetings
  },
  SET_CLOSE_MEETINGS(state, payload) {
    const meetings = payload
      .map((item) => {
        return {
          id: item.id,
          type: 'hr_meeting',
          additional_info: item.additional_info,
          author: item.author,
          client: item.client,
          title: item.client?.user_name,
          start: item.start,
          end: item.finish,
          dayCount: Math.floor(
            Math.abs(
              new Date().getTime() -
              new Date(item.start).getTime(),
            ) /
            (1000 * 3600 * 24),
          )
        }
      })
      .filter(item => item.dayCount === 0)

    state.closeMeetings = meetings
  },
  SET_CLOSE_CANDIDATE_MEETINGS(state, payload) {
    const meetings = payload.map(item => {
      return Object.assign(item, {
        date: item.last_connect,
        start: item.start !== null ? item.start : item.last_connect,
        end: item.end !== null ? item.end : item.last_connect,
        title: `${item.first_name} ${item.last_name}`,
        dayCount: Math.floor(
          Math.abs(
            new Date().getTime() -
            new Date(item.start).getTime(),
          ) /
          (1000 * 3600 * 24),
        )
      })
    })
      .filter(item => item.dayCount === 0)

    state.closeCandidateMeetings = meetings
  },
  SET_REPORTS(state, payload) {
    state.oneToOneReports = payload
      .sort((a, b) => a.date - b.date)
      .reverse()
  },
  SET_REPORT_USER(state, payload) {
    state.reportUser = payload
  },
  SET_CALENDAR_DETAILS(state, payload) {
    state.calendarDetails = payload
  },

  //vacations & days-off
  SET_VACATIONS_CALENDAR(state, payload) {
    state.vacationsCalendar = payload.map((item) => {
      return {
        type: 'Vacation',
        id: item.id,
        user: item.user,
        start: item.start === null && item.end === null ? item.date : item.start,
        end: item.start === null && item.end === null ? item.date : item.end,
        date: item.date,
        active: item.active,
        without_pay: item.without_pay,
        title: item.user !== null ? `${translations.vacation[store.getters['app/getSelectedLocale']]} ${item.user.user_name}` : `${translations.vacation[store.getters['app/getSelectedLocale']]}`
      }
    })
  },
  SET_DAYS_OFF_CALENDAR(state, payload) {
    state.daysOffCalendar = payload.map((item) => {
      return {
        type: 'DayOff',
        id: item.id,
        user: item.user,
        start: item.start === null && item.end === null ? item.date : item.start,
        end: item.start === null && item.end === null ? item.date : item.end,
        date: item.date,
        active: item.active,
        without_pay: item.without_pay,
        title: item.user !== null ? `${translations.dayOff[store.getters['app/getSelectedLocale']]} ${item.user.user_name}` : `${translations.dayOff[store.getters['app/getSelectedLocale']]}`
      }
    })
  },
  SET_HOLIDAYS_CALENDAR(state, payload) {
    state.holidayCalendar = payload.map((item) => {
      return {
        type: 'Holiday',
        id: item.id,
        user: item.user,
        start: item.date,
        end: item.date,
        date: item.date,
        active: 'approved',
        without_pay: false,
        title: 'Holiday',
        class: 'approved',
        description: item.description
      }
    })
  },
  SET_SICKLEAVE_CALENDAR(state, payload) {
    state.sickLealeCalendar = payload.map((item) => {
      return {
        type: 'Sickleave',
        id: item.id,
        user: item.user,
        start: item.start === null && item.end === null ? item.date : item.start,
        end: item.start === null && item.end === null ? item.date : item.end,
        date: item.date,
        active: item.active,
        without_pay: item.without_pay,
        title: item.user !== null ? `${translations.sickdays[store.getters['app/getSelectedLocale']]} ${item.user.user_name}` : `${translations.sickdays[store.getters['app/getSelectedLocale']]}`
      }
    })
  },
}
/* eslint-disable */
const actions = {
  getTodos({ commit }, type) {
    return new Promise((resolve, reject) => {
      DashboardService.get("getTodos", type)
        .then((response) => {
          if (type === 'hr') commit("SET_HR_TODOS", response.data.data);
          else commit("SET_GENERAL_TODOS", response.data.data);
          return resolve(response)
        }).catch(error => reject(error));
    })
  },
  // eslint-disable-next-line no-empty-pattern
  changeTodoStatus({ }, payload) {
    return new Promise((resolve, reject) => {
      DashboardService.put("changeStatus", payload.id, payload)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  // eslint-disable-next-line no-empty-pattern
  addNewTodo({ }, data) {
    return new Promise((resolve, reject) => {
      DashboardService.post('createTodo', {}, data)
        .then(response => {
          return resolve(response)
        }).catch(error => reject(error))
    })
  },
  // eslint-disable-next-line no-empty-pattern
  editTodo({ }, data) {
    return new Promise((resolve, reject) => {
      DashboardService.editTask(data)
        .then(response => {
          return resolve(response)
        }).catch(error => reject(error))
    })
  },
  // eslint-disable-next-line no-empty-pattern
  deleteTodo({ }, id) {
    return new Promise((resolve, reject) => {
      DashboardService.delete('deleteTodo', id)
        .then((response) => {
          return resolve(response)
        }).catch(error => reject(error))
    })
  },
  getCandidates({ commit }, params) {
    return new Promise((resolve, reject) => {
      DashboardService.get('getAllCandidates', params)
        .then((response) => {
          commit('SET_CANDIDATES', response.data.data)
          return resolve(response)
        })
        .catch(({ errors }) => reject(errors))
    })
  },
  getTags({ commit, state }, params) {
    const type = params.type || 'position'
    if (state.tags[type] && state.tags[type].length > 0) {
      return Promise.resolve({ data: { data: state.tags[type] } })
    }
    return new Promise((resolve, reject) => {
      DashboardService.get('getTags', params)
        .then((response) => {
          commit('SET_TAGS', { type, data: response.data.data })
          return resolve(response)
        })
        .catch(({ errors }) => reject(errors))
    })
  },

  createTag({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      DashboardService.post('createTag', {}, data.form, {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          const type = data.form.type || 'position'
          commit('SET_TAGS', { type, data: [] })
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

  async searchMatch(_, text) {
    try {
      const response = await ApiClient.post('/api/vacancies', { text });
      return response;
    } catch (error) {
      return await Promise.reject(error);
    }
  },

  async getSingleCandidate(_, id) {
    try {
      const response = await ApiClient.get(`/api/candidates/${id}`);
      return response;
    } catch (error) {
      return await Promise.reject(error);
    }
  },

  async getSingleCandidateEvent(_, id) {
    try {
      const response = await ApiClient.get(`/api/candidate-events/${id}`);
      return response;
    } catch (error) {
      return await Promise.reject(error);
    }
  },

  getCandidatesForFilter({ commit }, payload) {
    return new Promise((resolve, reject) => {
      DashboardService.get("getCandidatesInOnePage", payload)
        .then((response) => {
          commit("SET_CANDIDATES_FOR_FILTER", response.data.data.candidates);
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  getCandidateEventsForFilter({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const params = {
        per_page: payload.amount,
        id: payload.authorId
      };
      if (payload.from) {
        params.from = payload.from;
      }
      if (payload.to) {
        params.to = payload.to;
      }
      ApiClient.get('/api/candidate-events', { params })
        .then((response) => {
          const events = response.data.data || []
          const transformedEvents = events.map(event => {
            const candidateData = event.candidate || {}
            const isConfirmed = event.confirmed !== false
            const baseTitle = candidateData.first_name && candidateData.last_name 
              ? `${candidateData.first_name} ${candidateData.last_name}`.trim() 
              : candidateData.title || 'Candidate'
            
            const transformed = {
              ...candidateData,
              id: event.id,
              candidate_id: event.candidate_id,
              title: isConfirmed ? baseTitle : `⏰ ${baseTitle}`,
              confirmed: event.confirmed,
              link: event.link,
              comment: event.comment,
              first_name: candidateData.first_name || '',
              last_name: candidateData.last_name || '',
              status: candidateData.status || '',
            }
            transformed.start = event.starts
            transformed.end = event.ends
            
            if (!isConfirmed) {
              transformed.class = 'unconfirmed-event'
              delete transformed.background
            }
            
            return transformed
          })
          commit("SET_CANDIDATES_FOR_FILTER", transformedEvents);
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  async createCandidateEvent(_, payload) {
    try {
      const response = await ApiClient.post('/api/candidate-events', payload);
      return response;
    } catch (error) {
      return await Promise.reject(error);
    }
  },

  async updateCandidateEvent(_, { id, payload }) {
    try {
      const response = await ApiClient.put(`/api/candidate-events/${id}`, payload);
      return response;
    } catch (error) {
      return await Promise.reject(error);
    }
  },

  async deleteCandidateEvent(_, id) {
    try {
      const response = await ApiClient.delete(`/api/candidate-events/${id}`);
      return response;
    } catch (error) {
      return await Promise.reject(error);
    }
  },
  getCandidatesForDetailsFilter({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiClient.get('/api/candidates', { params: payload })
        .then((response) => {
          commit("SET_CANDIDATES_FOR_FILTER", response.data.data.candidates);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },


  getCandidatesStat({ commit }, param) {
    return new Promise((resolve, reject) => {
      const url = '/api/candidates/dashboard'
      const params = {
        from: param.startDate,
        to: param.endDate,
        page: param.page,
        per_page: param.per_page
      }
      Object.keys(params).forEach(k => {
        if (params[k] === undefined || params[k] === null || params[k] === '') delete params[k]
      })

      ApiClient.get(url, { params })
        .then(resolve)
        .catch(reject)
    })
  },


  createCandidate({ commit }, data) {
    return new Promise((resolve, reject) => {
      DashboardService.post('createCandidate', {}, data.form, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
        .then((createResponse) => {
          const candidateId = createResponse.data?.data?.id || createResponse.data?.id
          DashboardService.get("getCandidatesInOnePage", { authorId: data.id, amount: 50 })
            .then((response) => {
              commit("SET_CANDIDATES_FOR_FILTER", response.data.data.candidates);
              const result = {
                ...createResponse,
                candidateId: candidateId
              }
              return resolve(result);
            })
            .catch((error) => reject(error));
        })
        .catch((error) => reject(error))
    })
  },
  createInvoice({ commit }, payload) {
    return ApiClient.post('/api/invoices', payload, {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  updateInvoice({ commit }, { id, payload }) {
    return ApiClient.put(`/api/invoices/${id}`, payload, {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  async deleteInvoice({ commit }, invoiceId) {
    return await ApiClient.delete(`/api/invoices/${invoiceId}`)
  },

  async copyInvoice({ commit }, invoiceId) {
    return await ApiClient.post(`/api/invoices/duplicate/${invoiceId}`)
  },

  getInvoicesList({ commit }) {
    return new Promise((resolve, reject) => {
      ApiClient.get('/api/invoices', {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        }
      })
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  getSingleInvoice({ commit }, id) {
    return new Promise((resolve, reject) => {
      ApiClient.get(`/api/invoices/${id}`, {})
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  getSingleInvoiceBySlug({ commit }, slug) {
    return new Promise((resolve, reject) => {
      ApiClient.get(`/api/public/invoices/${slug}`, {
        skipAuth: true,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache'
        }
      })
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  editCandidate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      DashboardService.post('editCandidate', payload, payload.data, {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      })
        .then(() => {
          DashboardService.get("getCandidatesInOnePage", { authorId: payload.id, amount: 50 })
            .then((response) => {
              commit("SET_CANDIDATES_FOR_FILTER", response.data.data.candidates);
              return resolve(response);
            })
            .catch((error) => reject(error));
        })
        .catch((error) => reject(error))
    })
  },
  deleteCandidate({ commit }, data) {
    return new Promise((resolve, reject) => {
      DashboardService.delete('deleteCandidate', data)
        .then(() => {
          DashboardService.get("getCandidatesInOnePage", { authorId: data.id, amount: 50 })
            .then((response) => {
              commit("SET_CANDIDATES_FOR_FILTER", response.data.data.candidates);
              return resolve(response);
            })
            .catch((error) => reject(error));
        })
        .catch((error) => reject(error))
    })
  },

  deleteTag({ commit }, { id, type }) {
    return new Promise((resolve, reject) => {
      DashboardService.delete('deleteTag', id)
        .then((response) => {
          if (type) {
            commit('SET_TAGS', { type, data: [] })
          }
          return resolve(response);
        })
        .catch((error) => reject(error));
    })
  },

  //one-to-one meetings & reports
  addOneToOneReport({ commit }, payload) {
    return new Promise((resolve, reject) => {
      EventsService.createReport(payload)
        .then(() => {
          EventsService.getReports(payload.client_id)
            .then((response) => {
              commit('SET_REPORTS', response.data.data)

              return resolve(response)
            })
            .catch((error) => reject(error))
        })
        .catch((error) => reject(error))
    })
  },
  addOneToOne({ commit }, payload) {
    return new Promise((resolve, reject) => {
      EventsService.createOneToOneMeeting(payload.form)
        .then(() => {
          EventsService.getEvents(payload.id)
            .then((response) => {
              commit(
                'SET_ONE_TO_ONE_MEETINGS',
                response.data.data,
              )

              return resolve(response)
            })
            .catch((error) => reject(error))
        })
        .catch((error) => reject(error))
    })
  },
  getOneToOneMeetings({ commit }, param) {
    return new Promise((resolve, reject) => {
      EventsService.getEvents(param)
        .then((response) => {
          commit('SET_ONE_TO_ONE_MEETINGS', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },
  getCloseMeetings({ commit }, param) {
    return new Promise((resolve, reject) => {
      EventsService.getEvents(param)
        .then((response) => {
          commit('SET_CLOSE_MEETINGS', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },
  getCloseCandidateMeetings({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.amount = 50;
      DashboardService.get("getCandidatesInOnePage", payload)
        .then((response) => {
          commit("SET_CLOSE_CANDIDATE_MEETINGS", response.data.data.candidates);
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  getOneToOneReports({ commit }, id) {
    return new Promise((resolve, reject) => {
      EventsService.getReports(id)
        .then((response) => {
          commit('SET_REPORTS', response.data.data)

          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },
  setReportUser({ commit }, user) {
    commit('SET_REPORT_USER', user)
  },

  //vacations & days-off

  getCalendarDetails({ commit }, id) {
    return new Promise((resolve, reject) => {
      EventsService.getCalendarDetails(id)
        .then((response) => {
          commit('SET_CALENDAR_DETAILS', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },
  getVacationsCount({ commit }, id) {
    return new Promise((resolve, reject) => {
      EventsService.getVacationsCount(id)
        .then((response) => {
          commit('SET_VACATIONS_COUNT', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },
  getVacationsCalendar({ commit }) {
    return new Promise((resolve, reject) => {
      EventsService.getVacations()
        .then((response) => {
          commit('SET_VACATIONS_CALENDAR', response.data.data)

          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },
  getHolidayCalendar({ commit }) {
    return new Promise((resolve, reject) => {
      EventsService.getHolidays()
        .then((response) => {
          commit('SET_HOLIDAYS_CALENDAR', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

  async getJobCards(_, { perPage, page, search = "" }) {
    try {
      const response = await ApiClient.get("/api/job-cards", {
        params: {
          per_page: perPage,
          page,
          search,
        },
        headers: {
          Accept: "application/json",
        },
      });

      return response.data?.data || response.data;
    } catch (error) {
      throw error;
    }
  },


  createJobCard(_, payload) {
    const formData = new FormData();
    formData.append('title', payload.title);
    formData.append('published', payload.published ? 1 : 0);
    formData.append('mission', payload.mission);
    formData.append('results', payload.results);
    formData.append('competencies', payload.competencies);
    formData.append('vacancy', payload.vacancy);

    payload.toggledStack.forEach((tag, i) => {
      for (const key in tag) {
        formData.append(`stack[${i}][${key}]`, tag[key]);
      }
    });

    return ApiClient.post('/api/job-cards', formData, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });
  },


  async brandCv(_, { id }) {
    try {
      const res = await fetch(`${process.env.VUE_APP_API}/api/candidates/cv/${id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${store.getters["authorization/getAuthToken"]}`,
          'Accept': 'application/json',
        }
      });

      if (!res.ok) {
        throw new Error('Server returned ' + res.status);
      }

      const data = await res.json();
      return { data };
    } catch (error) {
      fireSwal('Error fetching branded CV.', 'error');
      return null;
    }
  },




  updateJobCard(_, { id, payload }) {
    const data = {
      title: payload.title,
      published: payload.published ? 1 : 0,
      mission: payload.mission,
      results: payload.results,
      competencies: payload.competencies,
      vacancy: payload.vacancy,
    };

    payload.toggledStack.forEach((tag, i) => {
      for (const key in tag) {
        data[`stack[${i}][${key}]`] = tag[key];
      }
    });

    const params = new URLSearchParams(data);

    return ApiClient.patch(`/api/job-cards/${id}`, params, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },




  getDaysOffCalendar({ commit }) {
    return new Promise((resolve, reject) => {
      EventsService.getDayOffs()
        .then((response) => {
          commit('SET_DAYS_OFF_CALENDAR', response.data.data)

          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },
  getSickleaveCalendar({ commit }, payload) {
    return new Promise((resolve, reject) => {
      EventsService.getSickleave(payload)
        .then((response) => {
          commit('SET_SICKLEAVE_CALENDAR', response.data.data)

          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },
  updateTag({ commit }, payload) {
    return new Promise((resolve, reject) => {
      EventsService.updateTag(payload.id, payload.form)
        .then((res) => {
          const type = payload.form.type || 'position'
          commit('SET_TAGS', { type, data: [] })
          return resolve(res)
        })
        .catch((error) => reject(error))
    })
  },
  approveVacation({ commit }, data) {
    return new Promise((resolve, reject) => {
      EventsService.updateVacation(data.eventId, data.form)
        .then(() => {
          EventsService.getVacations()
            .then((res) => {
              commit('SET_VACATIONS_CALENDAR', res.data.data)

              return resolve(res)
            })
            .catch((error) => reject(error))
        })
        .catch((error) => reject(error))
    })
  },
  approveDayOff({ commit }, data) {
    return new Promise((resolve, reject) => {
      EventsService.updateDayOff(data.eventId, data.form)
        .then(() => {
          EventsService.getDayOffs()
            .then((res) => {
              commit('SET_DAYS_OFF_CALENDAR', res.data.data)
              resolve(res.data.data)
            })
            .catch((error) => reject(error))
        })
        .catch((error) => reject(error))
    })
  },
  approveSickleave({ commit }, data) {
    return new Promise((resolve, reject) => {
      EventsService.updateSickday(data.eventId, data.form)
        .then(() => {
          EventsService.getSickleave()
            .then((res) => {
              commit('SET_SICKLEAVE_CALENDAR', res.data.data)
              resolve(res.data.data)
            })
            .catch((error) => reject(error))
        })
        .catch((error) => reject(error))
    })
  },
  addVacation({ commit }, data) {
    return new Promise((resolve, reject) => {
      EventsService.createVacation(data.form)
        .then((res) => {
          if (res !== undefined) {
            EventsService.getVacations()
              .then((res) => {
                commit('SET_VACATIONS_CALENDAR', res.data.data)

                resolve(res)
              })
              .catch((error) => reject(error))
          }

          return resolve(res)
        })
        .catch((error) => reject(error))
    })
  },
  addDayOff({ commit }, data) {
    return new Promise((resolve, reject) => {
      EventsService.createDayOff(data.form)
        .then((res) => {
          if (res !== undefined) {
            EventsService.getDayOffs()
              .then((res) => {
                commit('SET_DAYS_OFF_CALENDAR', res.data.data)

                resolve(res)
              })
              .catch((error) => reject(error))
          }

          return resolve(res)
        })
        .catch((error) => reject(error))
    })
  },
  /////////////////////////////////////
  addHoliday({ commit }, data) {
    return new Promise((resolve, reject) => {
      EventsService.createHoliday(data)
        .then((res) => {
          if (res !== undefined) {
            EventsService.getHolidays()
              .then((res) => {
                commit('SET_HOLIDAYS_CALENDAR', res.data.data)
                resolve(res)
              })
              .catch((error) => reject(error))
          }

          return resolve(res)
        })
        .catch((error) => reject(error))
    })
  },
  addSickLeave({ commit }, data) {
    return new Promise((resolve, reject) => {
      EventsService.createSickLeave(data.form)
        .then((res) => {
          if (res !== undefined) {
            EventsService.getSickleave()
              .then((res) => {
                commit('SET_SICKLEAVE_CALENDAR', res.data.data)
                resolve(res)
              })
              .catch((error) => reject(error))
          }

          return resolve(res)
        })
        .catch((error) => reject(error))
    })
  },
  editMeeting({ commit }, data) {
    return new Promise((resolve, reject) => {
      EventsService.editMeeting(data.eventId, data.form)
        .then(() => {
          EventsService.getEvents(data.userId)
            .then((response) => {
              commit('SET_ONE_TO_ONE_MEETINGS', response.data.data)
              return resolve(response)
            })
            .catch((error) => reject(error))
        })
        .catch((error) => reject(error))
    })
  },
  deleteMeeting({ commit }, data) {
    return new Promise((resolve, reject) => {
      EventsService.deleteMeeting(data.eventId)
        .then(() => {
          EventsService.getEvents(data.userId)
            .then((response) => {
              commit('SET_ONE_TO_ONE_MEETINGS', response.data.data)
              return resolve(response)
            })
            .catch((error) => reject(error))
        })
        .catch((error) => reject(error))
    })
  },
  deleteVacation({ commit }, data) {
    return new Promise((resolve, reject) => {
      EventsService.deleteVacation(data)
        .then(() => {
          EventsService.getVacations()
            .then((res) => {
              commit('SET_VACATIONS_CALENDAR', res.data.data)

              resolve(res)
            })
            .catch((error) => reject(error))
        })
        .catch((error) => reject(error))
    })
  },
  deleteDayOff({ commit }, data) {
    return new Promise((resolve, reject) => {
      EventsService.deleteDayOff(data)
        .then(() => {
          EventsService.getDayOffs()
            .then((res) => {
              commit('SET_DAYS_OFF_CALENDAR', res.data.data)

              resolve(res)
            })
            .catch((error) => reject(error))
        })
        .catch((error) => reject(error))
    })
  },

  deleteHoliday({ commit }, data) {
    return new Promise((resolve, reject) => {
      EventsService.deleteHoliday(data)
        .then(() => {
          EventsService.getHolidays()
            .then((res) => {
              commit('SET_HOLIDAYS_CALENDAR', res.data.data)

              resolve(res)
            })
            .catch((error) => reject(error))
        })
        .catch((error) => reject(error))
    })
  },


}

const getters = {
  candidatesData: (state) => state.candidatesData,
  candidatesList: (state) => state.candidatesList,
  searchList: (state) => state.candidatesForFilter,
  getCandidateInfo: (state) => state.currentCandidate,
  getHrTodos: (state) => state.hrTodos,
  getGeneralTodos: (state) => state.generalTodos,
  getHighestTaskId: (state) => state.highestTaskId,
  getOneToOneReports: (state) => state.oneToOneReports,
  getOneToOneMeetings: (state) => state.oneToOneMeetings,
  getVacationsCalendar: (state) => state.vacationsCalendar,
  getSickLealeCalendar: (state) => state.sickLealeCalendar,
  getDaysOffCalendar: (state) => state.daysOffCalendar,
  getHolidaysCalendar: (state) => state.holidayCalendar,
  getMeetingsUsers: (state) => state.meetingsUsers,
  getReportUser: (state) => state.reportUser,
  getCalendarDetails: (state) => state.calendarDetails,
  getCloseMeetings: (state) => state.closeMeetings,
  getCloseCandidateMeetings: (state) => state.closeCandidateMeetings,
  getVacationsCount: (state) => state.vacationsCount,
  getTags: (state) => (type) => state.tags[type] || [],
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}

